import { motion } from "motion/react";
import { Link } from "react-scroll";

const container = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.12, delayChildren: 0.1 },
  },
};

const item = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
};

export default function HeroSection() {
  return (
    <section id="heroSection" className="hero--section">
      <motion.div
        className="hero--section--content--box"
        variants={container}
        initial="hidden"
        animate="show"
      >
        <motion.div className="hero--section--content" variants={container}>
          <motion.p className="section--title" variants={item}>
            Hey, I'm Sanjay
          </motion.p>
          <h1 className="hero--section--title">
            <motion.span className="hero--section-title--color" variants={item} style={{ display: "inline-block" }}>
              Software Engineer
            </motion.span>{" "}
            <br />
            <motion.span className="hero--section-title--color" variants={item} style={{ display: "inline-block" }}>
              & Tech Entrepreneur
            </motion.span>
          </h1>
          <motion.p className="hero--section-description" variants={item}>
            Building enterprise-scale cloud applications and AI-driven solutions for Fortune 500 companies.
            <br />
            <br />
            Full-Stack, ML, & DevOps Engineer at Accenture with 5+ years architecting mission-critical systems for
            leading financial institutions through strategic AI and cloud transformation.
            <br />
            <br />
            Currently building <strong>skilldrop</strong> in the open — portable AI-agent skills that take a rough idea
            to a finished artifact — architecture docs, PRDs, on-call runbooks, threat models, exec decks.
          </motion.p>
        </motion.div>
        <motion.div className="hero--section--actions" variants={item}>
          <motion.a
            className="btn btn-primary"
            href="mailto:sanjay_ananth@icloud.com"
            whileHover={{ scale: 1.04 }}
            whileTap={{ scale: 0.98 }}
          >
            Get In Touch
          </motion.a>
          <Link
            to="OpenSource"
            smooth={true}
            offset={-70}
            duration={500}
            className="btn btn-outline-primary"
          >
            See What I'm Building
          </Link>
        </motion.div>
      </motion.div>
      <motion.div
        className="hero--section--img"
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.7, ease: "easeOut", delay: 0.2 }}
      >
        <img src="./img/about-me.png" alt="Hero Section" />
      </motion.div>
    </section>
  );
}
